<template>
    <div
      class="login-wrap"
    >
      <div class="login-box">
        <div class="language-box-wrap">
          <div class="language-box">
            <div class="language-top J-language">
              <a :href="url_cn" >中文 </a>
              <span></span>
              <a :href="url_en" class="curr">EN </a>
            </div>
          </div>
        </div>
  
        <!-- 表单 -->
        <slot></slot>
  
        <div class="account-box">
          <div class="box">
            <div class="text">
              SIAL Shanghai will be held at Shanghai New International Expo Center from May 19-21, 2025. The exhibition area reaches 200,000 square meters, expecting to attract 5,000 exhibitors from over 70 countires and regions, and more than 180,000 professional visitors from 110+ countries and regions. <br>
              SIAL Shenzhen will be held at Shenzhen Convention & Exhibition Center from 1st to 3rd September 2025. The exhibition will cover 60,000 square metres and is expected to attract over 1,500 exhibitors from 50 countries and regions and 67,000 professional visitors.
            </div>
          </div>
        </div>
      </div>
  
      <div class="login-left">
        <div class="logo">
          <img src="@/assets/images/logo.png" width="170" />
        </div>
        <div class="top">
          <div class="img">
            <!-- <p class="tit">SIAL in China</p> -->
  
            <div class="exhinfo">
              <template v-for="item in expo_area_list" :key="item.id">
                <div class="item">
                  <p class="tit">{{item.expo_name_en}}</p>
                  <p class="p1">{{setFormatTime(item.start_time, item.end_time, 'Y.M.D')}}</p>
                  <p class="p2">{{item.expo_addr_en}}</p>
                </div>
              </template>
            </div>
  
            <!-- <a href="https://www.sialchina.com/" target="_blank" class="linka"
              >Go to homepage <el-icon><Right /></el-icon></a> -->
          </div>
        </div>
        <div class="inspire">
          <el-carousel indicator-position="none" arrow="never" :interval="5000">
            <el-carousel-item v-for="item in 3" :key="item">
              <img src="@/assets/images/img1.png" />
            </el-carousel-item>
          </el-carousel>
        </div>
  
        <p class="copyright">
          Copyright © {{new Date().getFullYear()}} Comexposium-SIAL Exhibition Co., Ltd.
          <a href="http://beian.miit.gov.cn/" target="_blank"
            >京ICP备05075462号-1</a
          >
        </p>
      </div>
    </div>
  </template>
  
  <script>
  import { reactive, toRefs } from "vue";
  import { useStore } from "vuex";
  import { getAreaList, rangeFormatTime} from "@/utils/common";
  
  export default {
    setup() {
      const store = useStore();

      const state = reactive({
        url_cn: `${store.state.domain}${window.location.pathname.replace(/^(\/en)/, '')}`,
        url_en: `${store.state.domain_en}${window.location.pathname.replace(/^(\/en)/, '')}`,
        expo_area_list: [],
      });
      
      // 日期格式
      const setFormatTime = (start_time, end_time, format)=>{
        return rangeFormatTime(start_time, end_time, format)
      }
      
      // 获取展会基本信息
      getAreaList()
      .then((res) => {
        const { data } = res;
        state.expo_area_list = data;
      })
      .catch((err) => {});
  
      return {
        ...toRefs(state),
        setFormatTime
      };
    },
  };
  </script>
  
  
  